import { Injectable } from '@angular/core';
import { InspectionFactoryService } from '../../shared/services/inspectionFactory.service';
import { IndexedDbService } from '../../shared/services/indexedDb.service';
import { map } from 'rxjs/operators';
import { DataService } from '../../shared/services';

@Injectable()
export class StatesPluginFactoryService extends InspectionFactoryService {
  constructor(indexedDb: IndexedDbService, dataService: DataService) {
    super(indexedDb, dataService);
  }

  public updateState(inspectionId: string, pointId: string, pluginId: string, data: any) {
    if (this.isManager) {
      return this.dataService.getPlugin(inspectionId, pluginId).pipe(
        map((plugin) => {
          if (plugin) {
            this._updateState(plugin, data);
            return plugin;
          }
        })
      );
    }
    return this.getInspection(inspectionId).pipe(
      map((inspection) => {
        const plugin = inspection.allPlugins.find((p) => p.id === pluginId);
        if (plugin) {
          this._updateState(plugin, data);
          plugin.etag = new Date();
          this.updateInspection(inspection);
          return plugin;
        }
        return null;
      })
    );
  }

  private _updateState(plugin, data) {
    plugin.config.Action = data.action;
    plugin.config.Criticaly = data.criticaly;
    plugin.config.Priority = data.priority;
    plugin.config.Impact = {
      Availability: data.impact.availability,
      Productivity: data.impact.productivity,
      Quality: data.impact.quality,
      Safety: data.impact.safety
    };
    plugin.config.States = data.states;
  }
}
